// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d80f4137","453":"3dd9de04","455":"08194028","977":"303715cc"}[chunkId] + ".chunk.js";
};